const API_BASE_WARD_MENU_MODULES = '/api/wardmodules';

export const wardMenuModulesEndpoint = {
  getModules: API_BASE_WARD_MENU_MODULES,
  getModulesIds: (ids: number[]) =>
    `${API_BASE_WARD_MENU_MODULES}/ids?${ids.map((id) => `id=${id}`).join('&')}`,
  getModuleById: (id: number) => `${API_BASE_WARD_MENU_MODULES}/${id}`,
  createModule: API_BASE_WARD_MENU_MODULES,
  updateModule: (id: number) => `${API_BASE_WARD_MENU_MODULES}/${id}`,
  deleteModule: (id: number) => `${API_BASE_WARD_MENU_MODULES}/${id}`,
};
